<template>
  <div class="footer-fixed s-flex s-flex-col s-p-3">
    <div class="i title-description s-leading-snug s-text-neutral-600 s-mb-2">
      <i>{{ $t('onboarding.info') }}</i>
    </div>
    <i18n path="onboarding.assistance" tag="div" class="title-description s-leading-snug">
      <template #faqPage>
        <c-link
          href="https://www.chargebee.com/docs/2.0/cb_payments_faq.html"
          target="_blank"
        >
          {{ $t('onboarding.faqPage') }}
        </c-link>
      </template>
      <template #documentationPage>
        <c-link
          href="https://www.chargebee.com/docs/2.0/cb_payments.html"
          target="_blank"
        >
          {{ $t('onboarding.documentationPage') }}
        </c-link>
      </template>
    </i18n>
  </div>
</template>

<script>
export default {
  name: "IncrementalFooter"
};
</script>